import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
// import formFields from "../Create-Ad/formFields";
import formFields, { slotSizeOptions } from "../Create-Ad/formFields";
const mobileSlotSizes = [
    "300*250", "300*100", "320*50", "336*280", "320*480", "320*250", "300*400", "320*400", "250*250",
    "200*200", "250*360", "240*400", "300*600", "160*600", "120*600", "320*100", "320*75", "300*75", "300*50", "234*60", "120*60",
];

const desktopSlotSizes = [
    "300*250", "300*100", "336*280", "320*480", "320*250", "300*400", "480*320", "250*250",
    "200*200", "320*400", "250*360", "240*400", "300*600", "160*600", "120*600", "750*300", "580*400", "468*60",
    "728*90", "970*90", "970*250", "960*60", "640*60", "460*60", "580*90",
];

const validationSchema = Yup.object({
  gen_type: Yup.string().required("Gen Type is required"),
  site_id: Yup.string().required("Domain name is required"),
  ad_display_name: Yup.string().required("Ad Display Name is required"),
  adunit_name: Yup.string().required("Adunit Name is required"),
  platform_type: Yup.string().required("Platform Type is required"),
  htag: Yup.string().required("Head Tag is required"),
  btag: Yup.string().required("Body Tag is required"),
  htag: Yup.string().required("Head Tag is required"),
  btag: Yup.string().required("Body Tag is required"),
  device: Yup.string().required("Device Type is required"),
  slot_size: Yup.string().required("Slot Size is required"),
  // elmclidx: Yup.string().required("Element Class Index is required"),
  // design_format: Yup.string().required("Design Format is required"),
  design_format: Yup.string()
  .test(
    "is-valid-selection",
    "Design Format is required",
    (value) => value !== "__please_select__"
  ),
  status: Yup.string().required("status is required"),
  is_visible: Yup.string().required("Visible on reporting is required"),
  ad_multitags: Yup.array().of(
    Yup.object().shape({
      htag: Yup.string().nullable(),
      btag: Yup.string().required("Multi-tag Body Tag is required"),
      gptid: Yup.string().required("GPT-ID is required"),
      slot_var: Yup.string().nullable(),
      status: Yup.string().required("Status is required"),
      is_visible: Yup.string().required("Visible on reporting is required"),
      adunit_name: Yup.string().required("Adunit name is required"),
      custom_htag: Yup.string().required("Custom head tag is required"),
      custom_btag: Yup.string().required("Custom body tag is required"),
    })
  ),
});

const UpdateAd = () => {
  const { pubId, adunitId } = useParams();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState(null);
  const [domainList, setDomainList] = useState([]);
  const [selectedGenType, setSelectedGenType] = useState("");
  const [selectedDevice, setSelectedDevice] = useState("");
  const [slotOptions, setSlotOptions] = useState([]);
  const [cachedIdFields, setCachedIdFields] = useState({ elmid: "" });
  const [cachedClassFields, setCachedClassFields] = useState({ elmcl: "", elmclidx: "" });

  const token = localStorage.getItem("token");

  // useEffect(() => {
  //   axios
  //     .get(`http://34.100.197.173/stg/api/admin/getAdPlacementInfo/${pubId}/${adunitId}`,{
  //       headers: { Authorization: `Bearer ${token}` },
  //     }).then((res) => {
  //       const ad = res.data.data.ad_placement;
  //       const multitags = res.data.data.ad_multitags || [];

  //       setSelectedGenType(ad.gen_type);
  //       setSelectedDevice(ad.device);
  //       setSlotOptions(ad.device === "mobile" ? mobileSlotSizes : desktopSlotSizes);

  //       const transformed = formFields.reduce((acc, field) => {
  //         acc[field.name] = ad[field.name] ?? "";
  //         return acc;
  //       }, {});

  //       transformed.ad_multitags = multitags.map((tag) => ({
  //         ad_display_name: tag.ad_display_name || "",
  //         adunit_name: tag.adunit_name || "",
  //         adunit_id: tag.adunit_id || "0000",
  //         current_adunit: tag.current_adunit || "",
  //         reload_adunit: tag.reload_adunit || "",
  //         htag: tag.htag || "",
  //         btag: tag.btag || "",
  //         custom_htag: tag.custom_htag || "",
  //         custom_btag: tag.custom_btag || "",
  //         gptid: tag.gptid || "",
  //         slot_var: tag.slot_var || "",
  //         status: tag.status?.toString() || "0",
  //         is_visible: tag.is_visible?.toString() || "0",
  //       }));

  //       setInitialValues(transformed);
  //     });

  //   axios
  //     .get(`http://34.100.197.173/stg/api/admin/getAllSites/${pubId}`,{
  //       headers: { Authorization: `Bearer ${token}` },
  //     }).then((res) => setDomainList(res.data.data))
  //     .catch(() => setDomainList([]));
  // }, [pubId, adunitId]);
  
  const fetchAdData = async () => {
      try {
        const [adRes, domainRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getAdPlacementInfo/${pubId}/${adunitId}`, {
            headers: { Authorization: `Bearer ${token}`, Accept: "application/json", }
          }),
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getAllSites/${pubId}`, {
            headers: { Authorization: `Bearer ${token}`, Accept: "application/json", }
          })
        ]);
  
        const ad = adRes.data.data.ad_placement;
        const multitags = adRes.data.data.ad_multitags || [];
        const inferredGenType = ad.elmcl ? "class" : "id";
        setSelectedGenType(inferredGenType);
        setSelectedDevice(ad.device);
        console.log(ad.device);
        console.log(ad);
        
        // setSlotOptions(slotSizeOptions[value] || []);
        setSlotOptions(ad.device === "MOBILE" ? slotSizeOptions.MOBILE : slotSizeOptions.DESKTOP);
  
        const transformed = formFields.reduce((acc, field) => {
          acc[field.name] = ad[field.name] ?? "";
          return acc;
        }, {});
  
        transformed.ad_multitags = multitags.map((tag) => ({
          ad_display_name: tag.ad_display_name || "",
          adunit_name: tag.adunit_name || "",
          adunit_id: tag.adunit_id || "0000",
          current_adunit: tag.current_adunit || "",
          reload_adunit: tag.reload_adunit || "",
          htag: tag.htag || "",
          btag: tag.btag || "",
          custom_htag: tag.custom_htag || "",
          custom_btag: tag.custom_btag || "",
          gptid: tag.gptid || "",
          slot_var: tag.slot_var || "",
          status: tag.status?.toString() || "0",
          is_visible: tag.is_visible?.toString() || "0",
          cs: tag.cs || "",
        }));
  
        setInitialValues(transformed);
            // Cache ID / class fields
            setCachedIdFields({
              elmid: ad.elmid || "",
            });

            setCachedClassFields({
              elmcl: ad.elmcl || "",
              elmclidx: ad.elmclidx || "",
            });
        setDomainList(domainRes.data.data);
        //   if (cleanedValues.gen_type === "id") {
        //   cleanedValues.elmcl = "";
        //   cleanedValues.elmclidx = "";
        // } else if (cleanedValues.gen_type === "class") {
        //   cleanedValues.elmid = "";
        // }
      } catch (error) {
        // console.error("Error fetching ad or domain data", error);
        setDomainList([]);
        console.log(error);
        
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          navigate("/");
        }
        else {
          console.error("Error fetching data:", error);
        }
      }
    };

  // const handleDeviceChange = (value, setFieldValue) => {
  //   setSelectedDevice(value);
  //   setFieldValue("device", value);
  //   setFieldValue("slot_size", "");
  //   const options = value === "mobile" ? mobileSlotSizes : value === "desktop" ? desktopSlotSizes : [];
  //   setSlotOptions(options);
  // };

  const handleDeviceChange = (value, setFieldValue) => {
    setSelectedDevice(value);
    setFieldValue("device", value);
    setFieldValue("slot_size", ""); // Reset slot_size when device changes
    setSlotOptions(slotSizeOptions[value] || []);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const cleanedValues = {};
      for (const key in values) {
        cleanedValues[key] = values[key] === "__please_select__" ? "" : values[key];
      }
      if (cleanedValues.syncst) {
          cleanedValues.syncst = cleanedValues.syncst.replace("T", " ");
      }
      if (cleanedValues.syncend) {
          cleanedValues.syncend = cleanedValues.syncend.replace("T", " ");
      }
    const payload = {
      ...cleanedValues,
      visibleonpagesArr: Array.isArray(cleanedValues.visibleonpagesArr)
        ? cleanedValues.visibleonpagesArr.join(",")
        : cleanedValues.visibleonpagesArr || "",
      notvisibleonpagesArr: Array.isArray(cleanedValues.notvisibleonpagesArr)
        ? cleanedValues.notvisibleonpagesArr.join(",")
        : cleanedValues.notvisibleonpagesArr || "",
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/updateAdPlacement`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      alert("Ad Placement updated successfully");
      navigate(-1);
    } catch (error) {
      alert("Error updating ad: " + (error.response?.data?.message || error.message));
    } finally {
      setSubmitting(false);
    }
  };

  const handleAddMultitag = (push) => {
    push({
      ad_display_name: "",
      adunit_name: "",
      adunit_id: "0000",
      current_adunit: "",
      reload_adunit: "",
      htag: "",
      btag: "",
      custom_htag: "",
      custom_btag: "",
      gptid: "",
      slot_var: "",
      status: "0",
      is_visible: "0",
      cs: "",
    });
  };
  // Apply Customize
  const handleCustomizeApply = (values, setFieldValue) => {
  let updatedHtag = values.htag;
  let updatedBtag = values.btag;

  if (updatedHtag) {
    // Ensure googletag initialization is included
    updatedHtag = updatedHtag.replace(
      /(window\.googletag\s*=\s*window\.googletag\s*\|\|\s*\{cmd:\s*\[\]\};)/,
      `$1\n  googletag.cmd = googletag.cmd || [];`
    );

    // Replace defineSlot(...) with window.ACX_GPTSLOT = defineSlot(...)
    updatedHtag = updatedHtag.replace(
      /googletag\.defineSlot\(([^)]+)\)\.addService\(googletag\.pubads\(\)\);/,
      (match, slotArgs) => {
        const updatedSlotArgs = slotArgs.replace(/'div-gpt-ad-\d+-\d+'/g, "'ACX_GPTID'");
        return `window.ACX_GPTSLOT = googletag.defineSlot(${updatedSlotArgs}).addService(googletag.pubads());`;
      }
    );
  }

  if (updatedBtag) {
    updatedBtag = updatedBtag.replace(/'div-gpt-ad-\d+-\d+'/g, "'ACX_GPTID'");
  }

  setFieldValue("custom_htag", updatedHtag);
  setFieldValue("custom_btag", updatedBtag);
};

// Apply Cutomize for mutitag
  const handleMultiCustomize = (index, values, setFieldValue) => {
    let updatedHtag = values.ad_multitags[index].htag;
    let updatedBtag = values.ad_multitags[index].btag;
  
    if (updatedHtag) {
      updatedHtag = updatedHtag.replace(
        /(window\.googletag\s*=\s*window\.googletag\s*\|\|\s*\{cmd:\s*\[\]\};)/,
        `$1\n  googletag.cmd = googletag.cmd || [];`
      );
      updatedHtag = updatedHtag.replace(
         /googletag\.defineSlot\(([^)]+)\)\.addService\(googletag\.pubads\(\)\);/,
        (match, slotArgs) => {
        const updatedSlotArgs = slotArgs.replace(/'div-gpt-ad-\d+-\d+'/g, "'ACX_GPTID'");
        return `window.ACX_GPTSLOT = googletag.defineSlot(${updatedSlotArgs}).addService(googletag.pubads());`;
      }
      );
       if (updatedBtag) {
    updatedBtag = updatedBtag.replace(/'div-gpt-ad-\d+-\d+'/g, "'ACX_GPTID'");
  }
    }
  
    if (updatedBtag) {
      updatedBtag = updatedBtag.replace(/div-gpt-ad-\d+-0/g, "DIV-GPT-ID");
    }
  
    setFieldValue(`ad_multitags[${index}].custom_htag`, updatedHtag);
    setFieldValue(`ad_multitags[${index}].custom_btag`, updatedBtag);
  };
// Multitag Labels
const fieldLabelMap = {
  htag: "Head Tag",
  btag: "Body Tag",
  custom_htag: "Custom Head Tag",
  custom_btag: "Custom Body Tag",
  adunit_id: "Adunit ID",
  gptid: "GPT ID",
  slot_var: "Slot Var",
  is_visible: "Visible on Report",
  ad_display_name: "Ad Display Name",
};


  useEffect(() => {
    fetchAdData();
  }, [pubId, adunitId]);

  if (!initialValues) return <p>Loading...</p>;

  return (
    <section className="mainContainer">
      <div className="add-placement-page">
        <div className="add-placement-wrapper">
        {/* <h3 className="text-center">Update Ad Placement</h3> */}
        <div className="add-placement-header">
          <h2>Update Ad Placement</h2>
          <p>Configure the ad placement details below.</p>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ setFieldValue, values }) => (
            <Form>
              <div className="row">
                {formFields.map((field) => {
                  if (field.hidden) return null;
                  if (field.name === "elmid" && selectedGenType !== "id") return null;
                  if (["elmcl", "elmclidx"].includes(field.name) && selectedGenType !== "class") return null;
                  return (
                    <div className="col-md-12 mb-3" key={field.name}>
                      <label>{field.label}</label>
                      {field.type === "select" ? (
                        <Field
                          as="select"
                          name={field.name}
                          className="form-control"
                          disabled={field.disabled}
                          onChange={(e) => {
                            setFieldValue(field.name, e.target.value);
                            if (field.name === "device") handleDeviceChange(e.target.value, setFieldValue);
                            // if (field.name === "gen_type") setSelectedGenType(e.target.value);
                            if (field.name === "gen_type") {
    const selectedValue = e.target.value;
    setSelectedGenType(selectedValue);
    setFieldValue("gen_type", selectedValue);

    if (selectedValue === "class") {
      const elmclValue = cachedClassFields.elmcl?.trim()
        ? cachedClassFields.elmcl
        : 'CX-' + uuidv4();
      const elmclidxValue = cachedClassFields.elmclidx || "0";

      setFieldValue("elmcl", elmclValue);
      setFieldValue("elmclidx", elmclidxValue);
      setFieldValue("elmid", "");
      setCachedClassFields({ elmcl: elmclValue, elmclidx: elmclidxValue });
    }

    if (selectedValue === "id") {
      const elmidValue =
        cachedIdFields.elmid?.trim() ||
        values.elmid?.trim() ||
        'CX-' + uuidv4();

      setFieldValue("elmid", elmidValue);
      setFieldValue("elmcl", "");
      setFieldValue("elmclidx", "");

      setCachedIdFields({ elmid: elmidValue });
    }
  }

                          }}
                        >
                          {/* <option value="">Select {field.label}</option> */}
                          <option value="__please_select__">Please Select </option>
                          {(field.name === "slot_size"
                            ? slotOptions.map((size) => ({ value: size, label: size }))
                            : field.name === "site_id"
                            ? domainList.map((domain) => ({ value: domain.id, label: domain.domain }))
                            : field.options
                          ).map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </Field>
                      ) : field.type === "textarea" ? (
                        <>
                        <Field as="textarea" name={field.name} className="form-control" />
                            {field.name === "btag" && (
                              <div className="mt-2">
                                <button
                                  type="button"
                                  className="applyBtn applyCustomize"
                                  onClick={() => handleCustomizeApply(values, setFieldValue)}
                                >
                                  Apply Customize
                                </button>
                              </div>
                            )}
                        </>
                      ) : (
                        <Field type={field.type} name={field.name} className="form-control" readOnly={field.readonly} disabled={field.disabled} />
                      )}
                      <ErrorMessage name={field.name} component="div" className="text-danger" />
                    </div>
                  );
                })}

                <FieldArray name="ad_multitags">
                  {({ push, remove }) => (
                    <>
                      {values.ad_multitags.map((_, index) => (
                        <div key={index} className="border p-3 rounded mb-3">
                          <p style={{fontSize:"15px",fontWeight:"bold",color:"#2275ff"}}>MultiTag #{index + 1}</p>
                          {["ad_display_name", "adunit_name", "current_adunit", "reload_adunit", "htag", "btag", "custom_htag", "custom_btag", "gptid", "slot_var"].map((key) => (
                            <div className="mb-2" key={key}>
                              {/* <label>{key.replace(/_/g, " ")}</label> */}
                              <label>
                                {fieldLabelMap[key] || key.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())}
                              </label>
                              {/* <label>{key.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())}</label> */}
                              <Field name={`ad_multitags[${index}].${key}`} className="form-control" as={key.includes("tag") ? "textarea" : "input"} />
                              <ErrorMessage name={`ad_multitags[${index}].${key}`} component="div" className="text-danger" />
                                  {key === "btag" && (
                                  <div className="mt-2">
                                    <button
                                      type="button"
                                      className="applyBtn applyCustomize"
                                      onClick={() => handleMultiCustomize(index, values, setFieldValue)}
                                    >
                                      Apply Customize
                                    </button>
                                  </div>
                                )}
                            </div>
                          ))}
                          <div className="mb-2">
                            <label>Status</label>
                            <Field as="select" name={`ad_multitags[${index}].status`} className="form-control">
                              <option value="0">Yes</option>
                              <option value="1">No</option>
                            </Field>
                          </div>
                          <div className="mb-2">
                            <label>Visible on report</label>
                            <Field as="select" name={`ad_multitags[${index}].is_visible`} className="form-control">
                              <option value="0">Yes</option>
                              <option value="1">No</option>
                            </Field>
                          </div>
                          <div className="mb-2">
                            <label>Extra css Multitag</label>
                            <Field as="textarea" name={`ad_multitags[${index}].cs`} className="form-control">
                            {/* <Field className="form-control" as="textarea" name={`ad_multitags[${index}].cs`}></Field> */}
                            </Field>
                          </div>
                          <button type="button" onClick={() => remove(index)} className="deleteBtn applyBtn mt-3">Delete Multitag</button>
                        </div>
                      ))}
                      <div className="mb-3">
                        <button type="button" onClick={() => handleAddMultitag(push)} className="applyBtn addMultiTag mb-4">Add Multitag</button>
                      </div>
                    </>
                  )}
                </FieldArray>
              </div>
              <div className="publisher-form-actions">
               <button type="submit" className="applyBtn applyCustomize">Update</button>
               <button type="button" className="applyBtn cancelBtn" onClick={() => navigate(-1)}>Cancel</button>
              </div>
            </Form>
          )}
        </Formik>
        </div>
      </div>
    </section>
  );
};

export default UpdateAd;
